import { render, staticRenderFns } from "./Viviendas.vue?vue&type=template&id=3506fcaa&scoped=true&"
import script from "./Viviendas.vue?vue&type=script&lang=js&"
export * from "./Viviendas.vue?vue&type=script&lang=js&"
import style0 from "./Viviendas.vue?vue&type=style&index=0&id=3506fcaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506fcaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VCol,VRow,VSelect,VTooltip})
